var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurksAndCaicosIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 6v3.74c0 5.2 2.9 7.1 5.18 8.34C24.46 16.84 27 14.94 27 9.74V6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec400",
    d: "M22.18 17.48c-2.21-1.24-4.76-3.02-4.76-7.74V6.67h9.23v3.07c0 4.72-2.26 6.5-4.47 7.74"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a728",
    d: "M23.98 15.02c-.06-.55-.52-2.27-1.05-2.8-.53-.5-.75-.1-.75-.1s-.22-.4-.76.1c-.53.53-.98 2.25-1.05 2.8-.06.55.07.68.35.68.12.26.61.31.61.31s.55.36.85 0c.3.36.85 0 .85 0s.48-.05.6-.31c.29 0 .42-.13.35-.68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0082d",
    d: "M22.98 11.6c0 .48.12.86-.79.86-.9 0-.78-.38-.78-.86s.35-.87.78-.87.79.4.79.87"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9f3e",
    d: "M20.5 10.97c-.25.43-.64.13-.82-.37s-.86-.65-1.11-.79-.31-.37 0-.55c.31-.17.13-.39.35-.45-.29-.06-.54.1-.56 0s.2-.36.56-.4c-.3-.37-.13-1.15 0-1.17.12-.02.38.22.5.45.14.24.52.2.48.52.08.08.35.03.6.44s0 2.32 0 2.32"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff927f",
    d: "M20.61 10.91c-.35.03-.49-.28-.55-.74s-.7-.28-.4-.96.4-.27.43-.8.2-.96.36-.96.36.48.44.69.38.15.51.86c.14.7-.02 1.22-.2 1.38-.17.16-.25.18-.28.36s-.08.15-.3.17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9de0",
    d: "M20.61 7.91q.16.11 0 .38c-.11.19.07.38.08.7.01.3-.15.42-.11.57.03.16.28.46.25.82s-.1.47-.22.53-.06-.19-.04-.42c.02-.24-.13-.5-.21-.74s.1-.4.15-.64-.07-.45-.09-.7.2-.5.2-.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.25 8.51c.05-.34.03-.88-.08-1.07-.1-.18-.28-.3-.17-.33.1-.03.63.52.34 1.64s-.09-.24-.09-.24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.2 8.41c-.22-.12-.5-.43-.46-.6.02-.18.23-.5.26-.43.03.06-.1.26 0 .51.1.26.14.27.27.44.12.18-.08.08-.08.08m-.12.24c-.13-.15-1.52-1.05-1.38-1.11s1.34.69 1.53 1.11c.2.42-.15 0-.15 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24 8.92c-.51-.5-1.78-.6-1.71-.68.06-.07 1.68.07 1.9.54.23.47-.2.14-.2.14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M23.96 9.19a4 4 0 0 0-1.67-.35c-.1.02.97-.3 1.73.17s-.06.18-.06.18m.04.42a2.6 2.6 0 0 0-1.63-.1c-.16.1.45-.35.88-.3.42.04.83.13.95.2.11.09 0 .3-.2.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.35 8.41c-.08-.38-.08-.71-.6-.67-.51.04-.6 1-.48 2.36.13 1.34-.02 1.79-.05 1.86-.02.08.29-.26.27-.86s-.16-1.9-.11-2.39c.04-.48.27-.84.58-.75.32.1.25.34.24.63-.01.3.15-.18.15-.18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.69 10.92s.15-.09.36-1.15c.2-1.07-.24-1.53-.63-1.53-.4 0-.83.46-.63 1.53.2 1.06.36 1.15.36 1.15s-.48.46-.4.68c.06.22.67.23.67.23s.61 0 .68-.23c.07-.22-.41-.68-.41-.68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.6 8.51c-.05-.34-.03-.88.08-1.07.1-.18.28-.3.17-.33s-.63.52-.35 1.64.1-.24.1-.24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.65 8.41c.22-.12.49-.43.46-.6-.02-.18-.23-.5-.26-.43-.03.06.1.26 0 .51-.1.26-.14.27-.27.44-.12.18.07.08.07.08m.12.24c.13-.15 1.52-1.05 1.38-1.11s-1.34.69-1.53 1.11c-.2.42.15 0 .15 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.85 8.92c.51-.5 1.77-.6 1.71-.68-.06-.07-1.68.07-1.9.54-.23.47.19.14.19.14"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.89 9.19c.57-.3 1.58-.37 1.67-.35.1.02-.97-.3-1.73.17s.06.18.06.18m-.04.42a2.6 2.6 0 0 1 1.63-.1c.16.1-.45-.35-.88-.3a3 3 0 0 0-.95.2c-.11.09 0 .3.2.2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba5b1f",
    d: "M24.5 8.41c.08-.38.08-.71.6-.67.51.04.6 1 .47 2.36-.12 1.34.03 1.79.06 1.86s-.3-.26-.27-.86.15-1.9.11-2.39c-.04-.48-.27-.84-.58-.75-.32.1-.25.34-.24.63.01.3-.15-.18-.15-.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurksAndCaicosIslands);
export default __webpack_public_path__ + "static/media/turks-and-caicos-islands.a92d51df8cee5ec7fc5bd6954963cda8.svg";
export { ForwardRef as ReactComponent };